export default __webpack_public_path__ + "static/media/developer2.94c15f5e.jpg";